<gp-card [variant]="variant">
  <ng-content></ng-content>
</gp-card>
